export default __webpack_public_path__ + "static/media/eticket_new.edce632c.png";